import React from 'react';
import { Box } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

const List = ({ items }) => (
  <>
    {items.map((item, index) => (
      <Box
        data-testid="LIST_ITEM"
        key={item}
        py="3"
        borderTop={index > 0 ? '1' : '0'}
        borderColor="greys.alto"
      >
        {item}
      </Box>
    ))}
  </>
);

List.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default List;
